export default __webpack_public_path__ + "static/media/2.03b4528d.jpg";